/*
 * Fecha de entrega estimada en la ficha de producto.
 *
 * Las reglas y los calendarios son los MISMOS que usa la extension de checkout
 * (~/Desktop/onlyfresh-checkout-branding/extensions/checkout-delivery-estimate/
 *  src/lib/estimate.js) y el barrido del Hub. Si cambian los plazos, hay que
 * cambiarlos en los tres sitios: el cliente ve la misma fecha aqui y al pagar.
 *
 * Aqui no tenemos el codigo postal, solo el pais del mercado: Baleares recibe
 * los plazos de la peninsula. En el checkout, donde si hay CP, se corrige solo.
 *
 * Mejora progresiva: si algo falla o el pais no esta cubierto, no se toca nada
 * y el cliente sigue viendo el texto fijo del tema.
 */
(function () {
  'use strict';

  var ORIGIN_TZ = 'Europe/Madrid';

  var TRANSIT = {
    ES: { min: 1, max: 2, cap: 5, origin: 'ES', destination: 'ES' },
    PT: { min: 2, max: 4, cap: 7, origin: 'ES', destination: 'PT' },
    IT: { min: 1, max: 2, cap: 5, origin: 'IT', destination: 'IT' },
    DE: { min: 1, max: 2, cap: 7, origin: 'PL', destination: 'DE' },
    NL: { min: 3, max: 5, cap: 8, origin: 'PL', destination: 'NL' }
  };

  var CALENDARS = {
    // 02/11 e 07/12: traslados al lunes de Todos los Santos y de la Constitucion
    // (Decreto 75/2025, BOCM 229). Arganda cierra.
    ES: ['2026-08-15','2026-10-12','2026-11-01','2026-11-02',
         '2026-12-06','2026-12-07','2026-12-08','2026-12-25',
         '2027-01-01','2027-01-06','2027-03-25','2027-03-26','2027-05-01','2027-05-02',
         '2027-08-15','2027-10-12','2027-11-01','2027-12-06','2027-12-08','2027-12-25'],
    IT: ['2026-08-15','2026-11-01','2026-12-08','2026-12-25','2026-12-26',
         '2027-01-01','2027-01-06','2027-03-29','2027-04-25','2027-05-01','2027-06-02',
         '2027-08-15','2027-11-01','2027-12-08','2027-12-25','2027-12-26'],
    PL: ['2026-08-15','2026-11-01','2026-11-11','2026-12-25','2026-12-26',
         '2027-01-01','2027-01-06','2027-03-29','2027-05-01','2027-05-03','2027-05-27',
         '2027-08-15','2027-11-01','2027-11-11','2027-12-25','2027-12-26'],
    DE: ['2026-10-03','2026-12-25','2026-12-26',
         '2027-01-01','2027-03-26','2027-03-29','2027-05-01','2027-05-06','2027-05-17',
         '2027-10-03','2027-12-25','2027-12-26'],
    NL: ['2026-12-25','2026-12-26',
         '2027-01-01','2027-03-29','2027-04-27','2027-05-06','2027-05-17',
         '2027-12-25','2027-12-26'],
    PT: ['2026-08-15','2026-10-05','2026-11-01','2026-12-01','2026-12-08','2026-12-25',
         '2027-01-01','2027-03-26','2027-04-25','2027-05-01','2027-05-27','2027-06-10',
         '2027-08-15','2027-10-05','2027-11-01','2027-12-01','2027-12-08','2027-12-25']
  };

  var DAY = 86400000;

  /** Ano/mes/dia/hora/minuto en la hora del almacen. */
  function originParts(now) {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: ORIGIN_TZ, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    }).formatToParts(now);
    var out = {};
    parts.forEach(function (p) { if (p.type !== 'literal') out[p.type] = Number(p.value); });
    return out;
  }

  function civil(y, m, d) { return new Date(Date.UTC(y, m - 1, d, 12, 0, 0)); }
  function iso(date) { return date.toISOString().slice(0, 10); }
  function addDays(date, n) { return new Date(date.getTime() + n * DAY); }

  function isWorkingDay(date, holidays) {
    var dow = date.getUTCDay();
    if (dow === 0 || dow === 6) return false;
    return holidays.indexOf(iso(date)) === -1;
  }

  function nextWorkingDay(date, holidays) {
    var cursor = addDays(date, 1), guard = 0;
    while (!isWorkingDay(cursor, holidays) && guard++ < 30) cursor = addDays(cursor, 1);
    return cursor;
  }

  function addWorkingDays(date, count, holidays) {
    var cursor = date, left = count, guard = 0;
    while (left > 0 && guard++ < 120) {
      cursor = addDays(cursor, 1);
      if (isWorkingDay(cursor, holidays)) left--;
    }
    return cursor;
  }

  function compute(now, country, cutoffHour) {
    var config = TRANSIT[country];
    if (!config) return null;

    var originHolidays = CALENDARS[config.origin] || [];
    var deliveryHolidays = CALENDARS[config.destination] || [];

    var p = originParts(now);
    var orderDate = civil(p.year, p.month, p.day);
    var openToday = isWorkingDay(orderDate, originHolidays);
    var shipsToday = openToday && p.hour < cutoffHour;
    var shipDate = shipsToday ? orderDate : nextWorkingDay(orderDate, originHolidays);

    // Segundos hasta el corte que manda sobre la fecha que estamos enseñando:
    // el de hoy si aun se llega, y si no el del dia en que sale el pedido. Asi el
    // contador siempre dice la verdad: "pide antes de esto y te llega ese dia".
    // (En los dos cambios de hora del ano puede desviarse una hora, no mas.)
    var nowMs = Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
    var cutMs = Date.UTC(
      shipDate.getUTCFullYear(), shipDate.getUTCMonth(), shipDate.getUTCDate(),
      cutoffHour, 0, 0
    );
    var secondsLeft = Math.max(0, Math.round((cutMs - nowMs) / 1000));

    var from = addWorkingDays(shipDate, config.min, deliveryHolidays);
    var to = addWorkingDays(shipDate, config.max, deliveryHolidays);
    // Techo prometido, contado desde el dia del pedido (no desde la salida).
    var latest = config.cap ? addWorkingDays(orderDate, config.cap, deliveryHolidays) : null;
    if (latest && to > latest) to = latest;

    return {
      shipsToday: shipsToday,
      secondsLeft: secondsLeft,
      shipDate: shipDate,
      from: from,
      to: to,
      latest: latest,
      min: config.min,
      max: config.max
    };
  }

  /**
   * "20 de agosto", "August 20", "20. August": lo arma Intl segun el idioma.
   */
  function dayMonth(date, locale) {
    return new Intl.DateTimeFormat(locale, {
      day: 'numeric', month: 'long', timeZone: 'UTC'
    }).format(date);
  }

  /**
   * Rango corto: "20-21 de agosto". Se sustituye el trozo del dia dentro del
   * formato del idioma, asi en ingles sale "August 20-21" y no un hibrido raro.
   * Si cambia el mes, se escriben las dos fechas enteras.
   */
  function formatRange(from, to, locale) {
    if (from.getUTCMonth() !== to.getUTCMonth()) {
      return dayMonth(from, locale) + ' - ' + dayMonth(to, locale);
    }
    var parts = new Intl.DateTimeFormat(locale, {
      day: 'numeric', month: 'long', timeZone: 'UTC'
    }).formatToParts(to);
    return parts.map(function (part) {
      return part.type === 'day'
        ? from.getUTCDate() + '-' + to.getUTCDate()
        : part.value;
    }).join('');
  }

  function formatDate(date, locale) {
    try {
      var parts = new Intl.DateTimeFormat(locale, {
        weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC'
      }).formatToParts(date);
      return parts.map(function (part) {
        return part.type === 'literal' ? part.value.replace(/^,\s*/, ' ') : part.value;
      }).join('').trim();
    } catch (e) {
      return ('0' + date.getUTCDate()).slice(-2) + '/' + ('0' + (date.getUTCMonth() + 1)).slice(-2);
    }
  }

  /**
   * Rellena la plantilla y pone en negrita SOLO el valor (la fecha, el tiempo).
   * La plantilla viene de los locales del tema y los valores los genera Intl:
   * no hay nada escrito por el usuario, por eso se puede usar innerHTML.
   */
  function fill(tpl, values) {
    return String(tpl || '').replace(/__([A-Z]+)__/g, function (match, key) {
      return values[key] != null ? '<b>' + values[key] + '</b>' : match;
    });
  }

  function init() {
    var box = document.getElementById('of-delivery-estimate');
    if (!box) return;

    var country = (box.getAttribute('data-country') || '').toUpperCase();
    var locale = box.getAttribute('data-locale') || undefined;
    var cutoff = parseInt(box.getAttribute('data-cutoff'), 10);
    if (!(cutoff >= 1 && cutoff <= 23)) cutoff = 10;

    var urgentHours = parseFloat(box.getAttribute('data-urgent-hours'));
    if (!(urgentHours > 0 && urgentHours <= 12)) urgentHours = 3;
    var urgentSeconds = urgentHours * 3600;

    var main = document.getElementById('messaggio-consegna');
    var line = document.getElementById('of-delivery-countdown');

    function render() {
      var estimate;
      try {
        estimate = compute(new Date(), country, cutoff);
      } catch (e) {
        return false;
      }
      if (!estimate) return false;

      var same = estimate.from.getTime() === estimate.to.getTime();

      if (main) {
        main.innerHTML = same
          ? fill(box.getAttribute('data-tpl-single'), { DATE: dayMonth(estimate.from, locale) })
          : fill(box.getAttribute('data-tpl-range'), { RANGE: formatRange(estimate.from, estimate.to, locale) });
      }

      if (line) {
        // El contador solo aparece cuando de verdad urge: en las ultimas horas
        // antes del corte de hoy. El resto del tiempo seria ruido, o peor, una
        // cuenta atras de 20 horas que no mueve a nadie.
        var urge = estimate.shipsToday && estimate.secondsLeft > 0 && estimate.secondsLeft <= urgentSeconds;
        if (urge) {
          var h = Math.floor(estimate.secondsLeft / 3600);
          var m = Math.floor((estimate.secondsLeft % 3600) / 60);
          var tiempo = h > 0
            ? h + ' ' + box.getAttribute('data-unit-h') + ' ' + m + ' ' + box.getAttribute('data-unit-m')
            : Math.max(1, m) + ' ' + box.getAttribute('data-unit-m');
          line.innerHTML = fill(box.getAttribute('data-tpl-countdown'), { TIME: tiempo });
        }
        line.hidden = !urge;
      }
      pintaPopup(estimate, locale);
      return true;
    }

    /** Las mismas fechas, con mas detalle, dentro del popup "mas informacion". */
    function pintaPopup(estimate, locale) {
      var lista = document.getElementById('of-popup-dates');
      var ship = document.getElementById('of-popup-ship');
      var range = document.getElementById('of-popup-range');
      var latest = document.getElementById('of-popup-latest');
      var transit = document.getElementById('of-popup-transit');

      if (ship) ship.textContent = formatDate(estimate.shipDate, locale);
      if (range) {
        // Dentro del popup las tres fechas van en el mismo formato, con el dia de
        // la semana: aqui el cliente esta mirando el detalle, no el reclamo.
        range.textContent = estimate.from.getTime() === estimate.to.getTime()
          ? formatDate(estimate.from, locale)
          : formatDate(estimate.from, locale) + ' - ' + formatDate(estimate.to, locale);
      }
      if (latest && estimate.latest) latest.textContent = formatDate(estimate.latest, locale);
      if (lista) lista.hidden = false;

      if (transit) {
        var tpl = box.getAttribute('data-tpl-transit');
        if (tpl) transit.textContent = tpl.replace('__MIN__', estimate.min).replace('__MAX__', estimate.max);
      }
    }

    if (!render()) return;
    // Cada segundo: el contador baja y, al pasar el corte, la fecha se rehace sola.
    setInterval(render, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
